module.exports = __webpack_public_path__ + "img/78600.71a30161.jpg";